import { createMapLocationClickEvent } from '../eventCreators';
import { createMapLocationClickPayload } from '../dataHelpers/createMapLocationClickPayload';
import { mapLocationClick } from 'store/search/searchActions';

const emitMapLocationClickEvent = ({ payload }) => {
  return createMapLocationClickEvent(
    createMapLocationClickPayload({
      groupName: payload.groupName,
      itemName: payload.itemName,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [mapLocationClick]: emitMapLocationClickEvent };
